var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C10.9391 14 9.92172 14.4214 9.17157 15.1716C8.42143 15.9217 8 16.9391 8 18V34C8 35.0609 8.42143 36.0783 9.17157 36.8284C9.92172 37.5786 10.9391 38 12 38H36C37.0609 38 38.0783 37.5786 38.8284 36.8284C39.5786 36.0783 40 35.0609 40 34V18C40 16.9391 39.5786 15.9217 38.8284 15.1716C38.0783 14.4214 37.0609 14 36 14H32.828C32.2976 13.9999 31.789 13.7891 31.414 13.414L29.172 11.172C28.422 10.4218 27.4048 10.0002 26.344 10H21.656C20.5952 10.0002 19.578 10.4218 18.828 11.172L16.586 13.414C16.211 13.7891 15.7024 13.9999 15.172 14H12ZM24 32C24.7879 32 25.5681 31.8448 26.2961 31.5433C27.0241 31.2417 27.6855 30.7998 28.2426 30.2426C28.7998 29.6855 29.2417 29.0241 29.5433 28.2961C29.8448 27.5681 30 26.7879 30 26C30 25.2121 29.8448 24.4319 29.5433 23.7039C29.2417 22.9759 28.7998 22.3145 28.2426 21.7574C27.6855 21.2002 27.0241 20.7583 26.2961 20.4567C25.5681 20.1552 24.7879 20 24 20C22.4087 20 20.8826 20.6321 19.7574 21.7574C18.6321 22.8826 18 24.4087 18 26C18 27.5913 18.6321 29.1174 19.7574 30.2426C20.8826 31.3679 22.4087 32 24 32Z",
    fill: "#EEF0F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.866c676393e54681f7a61cd637917503.svg";
export { ForwardRef as ReactComponent };